export enum ViewState {
    Initializing,
    Loading,
    Saving,
    Ready
}

export enum ISortIcon {
    Sort,
    SortUp,
    SortDown
}

export interface IItemEditableListState {
    data: IdataListProps[];
    name: string;
    key: string;
}

export interface IdataListProps {
    id: number;
    content: string;
}

export interface IDateSearchingInputProps {
    children?: React.ReactNode;
    className?: string;
    onChangeOptionFrom: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onChangeOptionTo: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface ITableBoxProps<T> {
    listData: T[];
    renderTBodyLine: (value: T, index: number) => void;
    renderTHeadLine?: JSX.Element;
    headerStyle?: string;
}

export interface IAllCourseTableObject {
    courseProviderEmail: string;
    courseProvider: string;
    courseTitle: string;
    courseLecturer: string;
    courseAppointment: string;
    courseDisabled: boolean;
    courseParticipant: number;
    courseMaxParticipants: number;
}

export interface IAllAccountingTableObject {
    courseProviderId: number;
    courseProvider: string;
    courseAppointmentNumber: number;
    bookingRequest: number;
    totalCommission: number;
    alreadyAccounted: boolean;
    accountedDate?: string;
}

export interface ISimpleObject<T> {
    label: string;
    values: T[];
}

export interface TableBoxWithCollapseIconProps<T> {
    listData: T[];
    renderTHeadLine: string[];
    renderTbodyLine: string[];
    headerStyle?: string;
}

export interface TableBoxWithCollapseIconObject<T> {
    label: string;
    values: T[];
}

export interface IBooking {
    id?: number;
    courseId: number;
    courseName: string;
    courseProviderId: number;
    courseProviderName: string;
    bookingOption: string;
    appointment: string;
    state?: string;
    salutation?: string;
    firstName: string;
    lastName: string;
    name: string;
    email?: string;
    telephone?: string;
    street?: string;
    city?: string;
    zip?: string;
    note?: string;
    rejected?: boolean;
    reason?: string;
    updateDate?: string;
    insertDate?: string;
}

export interface IFieldsetBoxProps<T> {
    children?: React.ReactNode;
    fieldsetClass?: string;
    legendTitel: string;
    listData?: T[];
    renderTBodeyLine: (value: T, index: number) => void;
    renderTHeadLine?: JSX.Element;
    tableClass?: string;
}

export interface IFieldsetBoxWithCollapseButtonProps<T> {
    children?: React.ReactNode;
    fieldsetClass?: string;
    legendTitel: string;
    firstNumber: number;
    listData: T[];
    renderTBodeyLine: (value: T, index: number) => void;
    renderTHeadLine?: JSX.Element;
    tableClass?: string;
}

export interface IStatisticBoxCourseObject {
    courseProviderName: string;
    courseTitle: string;
    courseInsertDate: string;
}

export interface IStatisticBoxParticipantObject {
    courseTitle: string;
    registryProcent: string;
    bookingInsertDate: string;
}

export interface IDataForTheStatistic {
    activCourseProvider: number;
    activCourseAppointment: number;
    last3MonthRegistring: number[];
    last3MonthRequests: number[];
    currentlyBilled: number;
}

export interface IEmptyProps {
    children?: React.ReactNode;
}

export interface IEmptyState {
    children?: React.ReactNode;
}

export enum ImageChooserEditState {
    Display,
    Edit
}

export const KEYCODE_ENTER = 13;

export const MAPBOX_ACCESS_TOKEN =
    'pk.eyJ1IjoiZmRtYXBwIiwiYSI6ImNqcXM0ZGdqczA0a3g0MnBrOXNoazk1NXAifQ.Wwy2NqQQ8bRRQ-ELiyKksQ';



// WEBPACK FOOTER //
// ./src/constants.ts